import { MasterDataVehicleCreatePage } from "@/pages/master-data-vehicle-create";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_auth_requeired/master-data/vehicles/create",
)({
  component: () => <MasterDataVehicleCreatePage />,
});
